import { useState } from "react";

export default function TuroEssentials() {
  const [show, setShow] = useState(false);

  return (
    <div>
      <button
        onClick={() => setShow(!show)}
        className="relative text-blue-600 hover:underline"
      >
        Turo Host Essentials
      </button>

      {show && (
        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 w-[95vw] max-w-6xl bg-white shadow-lg border rounded p-6 z-50 text-left overflow-y-auto max-h-[80vh]">
          <button
            onClick={() => setShow(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
          >
            ×
          </button>

          {/* Grid layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* --- CARD 1: Bouncie --- */}
            <div className="rounded-2xl shadow-lg border border-gray-200 p-4 bg-white">
              <a
                href="https://www.amazon.com/dp/B07H8NS5MS?tag=diviseed-20"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://m.media-amazon.com/images/I/51adF7mP94L._AC_SX679_.jpg"
                  alt="Bouncie GPS Tracker"
                  className="w-full h-48 object-contain rounded-xl"
                />
              </a>
              <div className="mt-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  Bouncie GPS Tracker
                </h2>
                <p className="text-sm text-gray-500 mb-2">
                  Fleet-ready tracking & driver safety in one plug-and-play
                  device.
                </p>
                <ul className="text-sm text-gray-600 list-disc ml-5 space-y-1">
                  <li>Real-time GPS location + trip history</li>
                  <li>Speed, braking, and impact alerts</li>
                  <li>Monitors engine health & diagnostics</li>
                  <li>Easy install — OBD2 port</li>
                </ul>
                <a
                  href="https://www.amazon.com/dp/B07H8NS5MS?tag=diviseed-20"
                  target="_blank"
                  className="mt-4 block text-center bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 rounded-xl transition"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>

            {/* --- CARD 2: Lockbox --- */}
            <div className="rounded-2xl shadow-lg border border-gray-200 p-4 bg-white">
              <a
                href="https://www.amazon.com/dp/B0744PHLRR?tag=diviseed-20"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://m.media-amazon.com/images/I/61nAjcWclqL._AC_SX679_.jpg"
                  alt="KeyGuard SL-591-CVR Protective Lockbox Cover"
                  className="w-full h-48 object-contain rounded-xl"
                />
              </a>
              <div className="mt-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  KeyGuard Lockbox Cover
                </h2>
                <p className="text-sm text-gray-500 mb-2">
                  Weatherproof window cover for protecting your SL-591 lockbox.
                </p>
                <ul className="text-sm text-gray-600 list-disc ml-5 space-y-1">
                  <li>Durable, shatter-resistant polycarbonate</li>
                  <li>UV & weather protection</li>
                  <li>Fits KeyGuard SL-591 lockboxes</li>
                  <li>Secures with 3M adhesive or screws</li>
                  <li>Ideal for outdoor vehicle use</li>
                </ul>
                <a
                  href="https://www.amazon.com/dp/B0744PHLRR?tag=diviseed-20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 block text-center bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 rounded-xl transition"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>

            {/* --- CARD 3: Ozium --- */}
            <div className="rounded-2xl shadow-lg border border-gray-200 p-4 bg-white">
              <a
                href="https://www.amazon.com/dp/B086T517RH?tag=diviseed-20"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://m.media-amazon.com/images/I/717lvmQf9YL._AC_SX679_PIbundle-2,TopRight,0,0_SH20_.jpg"
                  alt="Ozium Air Sanitizer"
                  className="w-full h-48 object-contain rounded-xl"
                />
              </a>
              <div className="mt-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  Ozium Air Sanitizer Spray
                </h2>
                <p className="text-sm text-gray-500 mb-2">
                  Original scent spray that eliminates tough odors in cars and
                  enclosed spaces.
                </p>
                <ul className="text-sm text-gray-600 list-disc ml-5 space-y-1">
                  <li>Trusted odor eliminator used by pros</li>
                  <li>Neutralizes smoke & bacteria</li>
                  <li>Compact 3.5 oz can</li>
                  <li>Great post-rental or road trip</li>
                  <li>Strong, clean original scent</li>
                </ul>
                <a
                  href="https://www.amazon.com/dp/B086T517RH?tag=diviseed-20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 block text-center bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 rounded-xl transition"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
